<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="add-item-form" *ngIf="itemFormGroup">
	<form [formGroup]="itemFormGroup">
		<mat-tab-group [(selectedIndex)]="selectedTabIndex">
			<mat-tab formGroupName="itemInfoGroup" [label]="strings.CUSTOM_FIELD_TAB_INFO">
				<div class="custom-field-info-tab">
					<mat-grid-list cols="1" rowHeight="82px">
						<mat-grid-tile colspan="1">
							<mat-form-field floatLabel="always" class="full-width add-item-field">
								<mat-label>{{ strings.CUSTOM_FIELD_INFO_LABEL }}</mat-label>
								<input
									matInput
									#fieldLabel
									name="label"
									formControlName="label"
									automationId="customFieldLabel"
								/>
								<mat-error *ngIf="itemFormGroup.get('itemInfoGroup').get('label').hasError('required')">
									{{ strings.CUSTOM_FIELD_VALIDATION_REQUIRED(strings.CUSTOM_FIELD_INFO_LABEL) }}
								</mat-error>
								<mat-error *ngIf="itemFormGroup.get('itemInfoGroup').get('label').hasError('maxlength')">
									{{ strings.CUSTOM_FIELD_VALIDATION_MAXIMUM(customFieldService.MaxLabelLength) }}
								</mat-error>
							</mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile colspan="1">
							<mat-form-field class="full-width add-item-field">
								<mat-label>{{ strings.CUSTOM_FIELD_INFO_TYPE }}</mat-label>
								<mat-select #typeSelect formControlName="type" automationId="customFieldFieldInfoType">
									<mat-option *ngFor="let option of dataTypeKeys$ | async" [value]="option">
										{{ customFieldService.DataTypesMap.get(option) }}
									</mat-option>
								</mat-select>
								<mat-hint *ngIf="typeSelect.disabled">
									{{ strings.CUSTOM_FIELD_HINT_CANNOT_CHANGE(strings.CUSTOM_FIELD_INFO_TYPE | lowercase) }}
								</mat-hint>
							</mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile
							*ngIf="itemFormGroup.get('itemInfoGroup').get('type').value === 'number'"
							colspan="1"
						>
							<mat-form-field class="full-width add-item-field">
								<mat-label>{{ strings.CUSTOM_FIELD_INFO_UNIT }}</mat-label>
								<mat-select #unitSelect formControlName="unit" automationId="customFieldInfoUnit">
									<mat-option automationId="customFieldFilterControlNotSet">{{
										strings.UICONTROL_TEXT_NOT_SET
									}}</mat-option>
									<mat-option
										*ngFor="let unit of customFieldService.getNumberFieldUnits() | keyvalue"
										[value]="unit.key"
										automationId="customFieldFilterOptions"
									>
										{{ unit.value + ' (' + unit.key + ')' }}
									</mat-option>
								</mat-select>
								<mat-hint *ngIf="unitSelect.disabled">
									{{ strings.CUSTOM_FIELD_HINT_CANNOT_CHANGE(strings.CUSTOM_FIELD_INFO_UNIT | lowercase) }}
								</mat-hint>
							</mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile
							*ngIf="itemFormGroup.get('itemInfoGroup').get('type').value === 'dropDownList'"
							colspan="1"
						>
							<mat-form-field subscriptSizing="dynamic" floatLabel="always" class="full-width add-item-field">
								<mat-label>{{ strings.CUSTOM_FIELD_DROPDOWN_EDITOR_TITLE }}</mat-label>
								<input
									name="newChoice"
									#choiceName
									matInput
									[formControl]="newChoiceControl"
									automationId="customFieldChoiceControl"
								/>
							</mat-form-field>
							<button
								name="newChoiceButton"
								[disabled]="!newChoiceControl.valid || !newChoiceControl.value"
								mat-icon-button
								class="dropdown-list-add-button"
								color="primary"
								(click)="addDropdownChoice(choiceName)"
								automationId="customFieldNewChoiceButton"
							>
								<mat-icon>add_circle</mat-icon>
							</button>
							<mat-error
								class="hint-error-message dropdown-list-message"
								*ngIf="newChoiceControl.hasError('maxlength')"
							>
								{{ strings.CUSTOM_FIELD_VALIDATION_MAXIMUM(customFieldService.MaxLabelLength) }}
							</mat-error>
							<mat-error
								class="hint-error-message dropdown-list-message"
								*ngIf="
									itemFormGroup.get('itemInfoGroup').get('listOfValues') &&
									itemFormGroup.get('itemInfoGroup').get('listOfValues').hasError('required') &&
									!newChoiceControl.hasError('maxlength')
								"
							>
								{{
									strings.CUSTOM_FIELD_VALIDATION_ATLEASTONE(
										strings.CUSTOM_FIELD_DROPDOWN_EDITOR_PLACEHOLDER | lowercase
									)
								}}
							</mat-error>
							<mat-error
								class="hint-error-message dropdown-list-message"
								*ngIf="
									itemFormGroup.get('itemInfoGroup').get('listOfValues') &&
									itemFormGroup.get('itemInfoGroup').get('listOfValues').hasError('allDisabled') &&
									!newChoiceControl.hasError('maxlength')
								"
							>
								{{
									strings.CUSTOM_FIELD_VALIDATION_ATLEASTONEVISIBLE(
										strings.CUSTOM_FIELD_DROPDOWN_EDITOR_PLACEHOLDER | lowercase
									)
								}}
							</mat-error>
						</mat-grid-tile>
						<mat-grid-tile
							*ngIf="itemFormGroup.get('itemInfoGroup').get('type').value === 'dropDownList'"
							colspan="1"
							[rowspan]="getNumberOfDropdownChoiceRows()"
							name="dropdownList"
						>
							<div class="full-width dropdown-list-container">
								<mat-list
									*ngIf="listOfValuesControl?.length > 0"
									formArrayName="listOfValues"
									class="dropdown-list-blocks full-width add-item-field"
									cdkDropList
									(cdkDropListDropped)="reorderDropdownChoice($event, listOfValuesControl.value)"
									name="choices"
									selectable="false"
								>
									<ng-container *ngFor="let choice of listOfValuesControl.controls; let i = index">
										<mat-list-item cdkDrag name="choiceList" class="dropdown-list">
											<mat-form-field
												appearance="fill"
												class="full-width add-item-field custom-height"
												subscriptSizing="dynamic"
											>
												<input #choiceName matInput [formControl]="choice.get('label')" name="label" />
												<mat-icon
													matSuffix
													name="delete"
													*ngIf="choice.value.local"
													matListItemIcon
													class="clickable"
													(click)="deleteDropdownChoice(i)"
													>delete
												</mat-icon>
												<mat-checkbox
													matSuffix
													*ngIf="!choice.value.local"
													[formControl]="choice.get('isEnabled')"
													class="dropdown-action-enabled"
												></mat-checkbox>
												<mat-icon
													matSuffix
													*ngIf="!choice.value.local"
													name="icons"
													[color]="choice.get('isEnabled').value ? 'primary' : 'grey'"
													class="clickable dropdown-action-enabled-icon"
													matListItemIcon
												>
													{{ choice.get('isEnabled').value ? 'visibility' : 'visibility_off' }}
												</mat-icon>
												<mat-icon matSuffix name="drag" class="draggable" matListItemIcon
													>drag_handle</mat-icon
												>
											</mat-form-field>
											<mat-error
												class="choice-hint-error-message full-width"
												*ngIf="choice.get('label').hasError('maxlength')"
											>
												{{ strings.CUSTOM_FIELD_VALIDATION_MAXIMUM(customFieldService.MaxLabelLength) }}
											</mat-error>
											<mat-error
												class="choice-hint-error-message full-width"
												*ngIf="choice.get('label').hasError('required')"
											>
												{{
													strings.CUSTOM_FIELD_VALIDATION_REQUIRED(
														strings.CUSTOM_FIELD_DROPDOWN_EDITOR_PLACEHOLDER
													)
												}}
											</mat-error>
										</mat-list-item>
									</ng-container>
								</mat-list>
							</div>
						</mat-grid-tile>
						<mat-grid-tile colspan="1" rowspan="3">
							<div class="full-width">
								<div class="ticket-type-container">
									<mat-checkbox
										formControlName="itemAllTicketsControl"
										[indeterminate]="allTicketsIndeterminate"
										checkboxPosition="before"
									>
										{{ strings.CUSTOM_FIELD_INFO_TICKET_TYPES }}
									</mat-checkbox>
									<mat-error
										class="hint-error-message"
										*ngIf="itemFormGroup.get('itemInfoGroup').get('ticketTypes').hasError('required')"
									>
										{{ strings.CUSTOM_FIELD_VALIDATION_REQUIRED(strings.CUSTOM_FIELD_INFO_TICKET_TYPES) }}
									</mat-error>
								</div>
								<mat-selection-list #allTicketTypes class="full-width" formControlName="ticketTypes">
									<div class="all-ticket-type-container" automationId="customFieldTicketTypes">
										<mat-list-option
											name="ticketTypes"
											*ngFor="let type of customFieldService.TicketTypesKeys"
											color="primary"
											checkboxPosition="before"
											[value]="type"
										>
											{{ customFieldService.TicketTypesMap.get(type) }}
										</mat-list-option>
									</div>
								</mat-selection-list>
							</div>
						</mat-grid-tile>
					</mat-grid-list>
				</div>
			</mat-tab>
			<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-6721 -->
			<mat-tab [label]="strings.PROJECT_ACTION_ROLES">
				<div class="custom-field-role-tab-top">
					<div class="justify-space-between">
						<span class="h3-heading-bold">{{ strings.CUSTOM_FIELD_SHOW_ON_TICKET_FOR_ROLES }}</span>
						<mat-menu #menu="matMenu">
							<button mat-menu-item automationId="customFieldSelectRolesAll" (click)="selectAllRoles()">
								{{ strings.CUSTOM_FIELD_SELECT_ROLES_ALL }}
							</button>
							<button mat-menu-item automationId="customFieldSelectRolesNone" (click)="deselectAllRoles()">
								{{ strings.CUSTOM_FIELD_SELECT_ROLES_NONE }}
							</button>
						</mat-menu>
						<button mat-icon-button [matMenuTriggerFor]="menu">
							<mat-pseudo-checkbox
								class="mat-pseudo-checkbox ng-star-inserted"
								ng-reflect-state="unchecked"
								ng-reflect-disabled="false"
								automationId="genericCheckBox"
							></mat-pseudo-checkbox>
							<div class="mat-select-arrow-wrapper">
								<div class="mat-select-arrow"></div>
							</div>
						</button>
					</div>
					<cdk-virtual-scroll-viewport [itemSize]="FIELD_ROLE_ITEM_HEIGHT" class="custom-field-role-tab">
						<mat-selection-list
							#allRoleOptions
							*ngIf="planState.rolesApi.data.list$ | async as roleMap"
							[formControl]="itemFormGroup.get('itemInfoGroup').get('roles')"
						>
							<ng-container *ngFor="let role of roleMap | keyvalue; let i = index">
								<mat-list-option color="primary" [value]="role.value.$id">
									<div class="all-role-container">
										<mat-icon
											*ngIf="role.value.view.color"
											class="role-list-item-color"
											[ngStyle]="{ background: role.value.view.color }"
										>
										</mat-icon>
										<span class="all-role-text">{{ role.value.view.roleName }}</span>
									</div>
								</mat-list-option>
								<mat-divider></mat-divider>
							</ng-container>
						</mat-selection-list>
					</cdk-virtual-scroll-viewport>
				</div>
			</mat-tab>
			<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-6721 -->
		</mat-tab-group>
	</form>
	<mat-slide-toggle class="show-ticket-form-toggle" content="extraControls" [formControl]="isEnabledControl">
		{{ strings.CUSTOM_FIELD_SHOW_ON_TICKET }}
	</mat-slide-toggle>
	<mat-slide-toggle class="required-field-form-toggle" [formControl]="isRequiredControl">
		<span>{{ strings.CUSTOM_FIELD_REQUIRED_CUSTOM_FIELD }}</span>
	</mat-slide-toggle>
	<mat-divider></mat-divider>
	<button-footer
		(buttonSaveOrClose)="handleItemEvent({ type: 'Save', event: $event })"
		[disabled]="!canSave()"
		[saveOrCloseButtonText]="strings.UICONTROL_TEXT_SAVE | uppercase"
	>
		<span leftButton class="footer-required-fields">
			{{ strings.CUSTOM_FIELD_REQUIRED_CUSTOM_FIELDS_INFO }}
		</span>
		<button
			middleButton
			mat-button
			color="primary"
			[disabled]="!canCancel()"
			(click)="handleItemEvent({ type: 'Cancel', event: $event })"
		>
			{{ strings.UICONTROL_TEXT_DISCARD | uppercase }}
		</button>
	</button-footer>
</div>
